"use client";
import { Paginate } from "@/components/common";
import BrandCard from "@/components/common/brand-card/brand-card";
import {
  SearchBrandType,
  SearchServerParams,
  searchBrands,
} from "@/services/search.service";
import { useEffect, useState } from "react";
import { useTranslations } from "next-intl";
import { useSearchParams } from "next/navigation";
interface BrandWrapperProps {
  initialData: SearchBrandType[];
  serverParams: SearchServerParams;
  totalPages: number;
}
function BrandWrapper({
  initialData,
  serverParams,
  totalPages,
}: BrandWrapperProps) {
  const t = useTranslations();
  const serachParams = useSearchParams();
  const serachQ = serachParams.get("q");
  const [brands, setBrands] = useState<SearchBrandType[]>(initialData);
  const [params, setParams] = useState<SearchServerParams>(serverParams);
  const onPageChange = (page: number) => {
    setParams({ ...params, page: page });
    fetchBrands({ ...params, page: page });
  };
  const fetchBrands = (params: SearchServerParams) => {
    searchBrands(params).then((res) => {
      setBrands(res?.data);
    });
  };

  useEffect(() => {
    if (serachQ) {
      setParams({ ...params, q: serachQ });
      fetchBrands({ ...params, q: serachQ });
    }
  }, [serachQ]);

  if (brands?.length === 0)
    return <h6 className="text-body-2 text-grey-500">No Brands</h6>;
  return (
    <>
      {brands?.length > 0 && (
        <>
          <div className="flex -mx-1.5 flex-wrap">
            {brands.map((brand, index) => (
              <div
                key={index}
                className="w-6/12 sm:w-4/12 md:w-6/12 lg:w-4/12 xl:w-3/12 px-1 sm:px-1.5 mb-4"
              >
                <BrandCard
                  brand_id={brand.id}
                  brand_logo={brand.brand_logo}
                  name={brand.brand_name}
                  subscribers={brand.no_of_subscribers}
                  description={brand.brand_bio}
                  variant={brand.plan_name}
                />
              </div>
            ))}
          </div>
          <Paginate
            totalPages={totalPages}
            currentPage={params.page}
            onPageChange={onPageChange}
          />
        </>
      )}
    </>
  );
}

export default BrandWrapper;
